export default {
  Login: {
    path: '/login'
  }
};
